module.exports = __webpack_public_path__ + "static/img/indexVersion05.75c1acf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/indexVersion05.jpg
// module id = cHz/
// module chunks = 3